import { render, staticRenderFns } from "./Crowded_noreload.vue?vue&type=template&id=12a7449d&scoped=true&"
import script from "./Crowded_noreload.vue?vue&type=script&lang=js&"
export * from "./Crowded_noreload.vue?vue&type=script&lang=js&"
import style0 from "./Crowded_noreload.vue?vue&type=style&index=0&id=12a7449d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a7449d",
  null
  
)

export default component.exports